/** Resume at persisted index, or 0 when unset. Returns null when the index is out of range. */
export const resolveTourResumeStepIndex = (stepCount: number, stepIndex: number | null) => {
  if (!stepCount) return null
  if (stepIndex == null) return 0
  if (stepIndex < 0 || stepIndex >= stepCount) return null

  return stepIndex
}
